module.exports = __webpack_public_path__ + "img/Self.1c3b51ba.svg";